<template>
    <main>
        <banner :title="getText('about-title')"/>

        <section class="bg-gray-700">
            <workplace-experience/>
        </section>
    </main>
</template>

<script>
	import {mapGetters} from 'vuex';
    import WorkplaceExperience from "../components/WorkplaceExperience";
    import Banner from "./Banner";

	export default {
		name: "About",
        components: {WorkplaceExperience, Banner},
        computed: {
			...mapGetters(['getText'])
		},
	}
</script>